import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withRouteData } from 'react-static';

import Page from '../containers/Page';
import Header from '../components/main/header/Header';
import Footer from '../components/main/footer/Footer';
import Hero from '../components/home/Hero';
import Intro from '../components/home/Intro';
import Tiles from '../components/home/Tiles';
import Masterpiece from '../components/home/Masterpiece';
import Usps from '../components/home/Usps';
import Player from '../components/home/Player';
import Pricing from '../components/home/Pricing';
import Charts from '../components/home/Charts';
import Magazine from '../components/home/Magazine';
import Testimonial from '../components/home/Testimonial';
import Marquee from '../components/home/Marquee';
import QuickLinks from '../components/home/QuickLinks';
import Outro from '../components/home/Outro';

const Main = styled.main`
  font-family: var(--ff-sans);
  background-color: var(--b-black);
  overflow-x: hidden;
`;

const Home = ({ gtmContainerId, magazine }) => (
  <Page header={false} footer={false} metaData={{}} showSmartBanner gtmContainerId={gtmContainerId}>
    <Header />
    <Main>
      <Hero />
      <Intro />
      <Tiles />
      <Masterpiece />
      <Usps />
      <Player />
      <Pricing />
      <Charts />
      <Magazine articles={magazine} />
      <Testimonial />
      <Marquee />
      <QuickLinks />
      <Outro />
    </Main>
    <Footer />
  </Page>
);

Home.propTypes = {
  gtmContainerId: PropTypes.string,
  magazine: PropTypes.array,
};

export default withRouteData(Home);



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/pages/Home.js